import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../services/accountService";

const UpdatePassword = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showError, setShowError] = useState("hidden");
  const [errorText, setErrorText] = useState("");
  const [showSuccess, setShowSuccess] = useState("hidden");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      setErrorText(() => "new password does not match");
      setShowError(() => "");
      setTimeout(() => {
        setShowError(() => "hidden");
      }, 5000);
      return;
    }
    try {
      await changePassword(oldPassword, newPassword);
      setShowSuccess(() => "");
      setOldPassword(() => "");
      setNewPassword(() => "");
      setConfirmNewPassword(() => "");
    }
    catch(e) {
      setErrorText(() => {
        const err = e.response.data.error
        if (err.toLowerCase().includes("incorrect username or password")) {
          return "Incorrect old password.";
        }
        return err;
      });
      setShowError(() => "");
      setTimeout(() => {
        setShowError(() => "hidden");
      }, 5000);
      return;
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Update Password
        </h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Old Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              New Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Confirm New Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <h6 className={`text-red-800 ${showError}`}>
              {errorText}
            </h6>
            <h6 className={`text-green-800 ${showSuccess}`}>
              Password has been updated
            </h6>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdatePassword;
